import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-identification',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './identification.component.html',
    styleUrl: './identification.component.scss'
})
export class IdentificationComponent {
    title = 'Identification Verification';
}
